"use strict";

/* Directives */
_BannerFlowApp.directive("feedFieldBrowser", function () {
    return {
        restrict: "E",
        replace: true,
        scope: {
            feedLeafs: "=feedLeafs",
            callback: "=callback",
            multiple: "=multiple",
            parentMode: "=parentMode",
            selectedFields: "=?selectedFields",
            hideButtons: "=hideButtons",
            fullHeight: "=fullHeight",
            preservData: "=preservData"
        },
        controller: function ($scope, $attrs) {
            $scope.feedStartNode = null;

            if (!$scope.preservData) $scope.selectedFields = new Array();

            if ($scope.preservData && $scope.selectedFields && $scope.selectedFields.length > 0) {
                var initFunc = function (node) {
                    var selectedItem = _.find($scope.selectedFields, function (n) {
                        return n.Path === node.Path;
                    });

                    node.selected = selectedItem ? true : false;

                    for (var i = 0, count = node.Descendants.length; i < count; i++) {
                        initFunc(node.Descendants[i]);
                    }
                };
                initFunc($scope.feedLeafs);
            }

            $scope.feedStartNode = angular.copy($scope.feedLeafs);

            $scope.selectField = function (field) {
                if (!$scope.multiple) {
                    if (Object.prototype.toString.call(field) != "[object Array]") {
                        field.selected = !field.selected;
                        if ($scope.callback) {
                            if ($scope.$parent.closeThisDialog) $scope.$parent.closeThisDialog();

                            $scope.callback(field);
                        }
                        return;
                    } else {
                        return;
                    }
                }

                if (Object.prototype.toString.call(field) === "[object Array]") {
                    var doSelect = false;
                    for (var i = 0; i < field.length; i++) {
                        if (!field[i].selected && field[i].Descendants.length === 0) {
                            doSelect = true;
                            break;
                        }
                    }
                    for (var i = 0; i < field.length; i++) {
                        if (field[i].Descendants.length === 0) {
                            field[i].selected = doSelect;
                        }
                    }
                } else {
                    field.selected = !field.selected;
                }
                if ($scope.selectedFields) {
                    $scope.selectedFields = new Array();
                    func($scope.feedStartNode);
                }
            };

            var func = function (node) {
                var item = {
                    Id: node.Id,
                    Name: node.Name,
                    Path: node.Path,
                    Data: node.Data
                };
                if (node.selected) $scope.selectedFields.push(item);

                for (var i = 0, count = node.Descendants.length; i < count; i++) {
                    func(node.Descendants[i]);
                }
            };

            $scope.callCalback = function (isCancel) {
                if ($scope.$parent.closeThisDialog) $scope.$parent.closeThisDialog();

                if (isCancel) {
                    if ($scope.callback) {
                        $scope.callback(null);
                    }
                    return;
                }

                if ($scope.callback) {
                    $scope.selectedFields = new Array();
                    func($scope.feedStartNode);
                    $scope.callback($scope.selectedFields);
                }
            };
        },
        link: function (scope, element, attrs, ngModel) {},
        template:
            "<ng-include src=\"'/legacy-app/js/directives/feedFieldBrowser/feedFieldBrowser.html'\"></ng-include>"
    };
});
